export const sidebar = {
      development: 'Technical catalog',
      dashboard: 'Dashboard',
      products: 'Products',
      inventory: 'Inventory',
      movements: 'Movements',
      reports: 'Reports',
      settings: 'Settings',
      logout: 'Log out',
    } as const;
